import { render, staticRenderFns } from "./CartIconAndBubble.vue?vue&type=template&id=6b0cd472&"
import script from "./CartIconAndBubble.vue?vue&type=script&lang=js&"
export * from "./CartIconAndBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports